import { ViewIds } from '@ardoq/api-types';
import { DropdownOptionType } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { IconName } from '@ardoq/icons';
import { t, type I18nLocale } from '@ardoq/i18n';
import { SettingsType, type SettingsConfig } from '@ardoq/view-settings';
import type { SpiderViewSettings } from '@ardoq/xyz-charts';
import type { NumericField } from 'tabview/chartShared/types';
import { handleStoreSetting } from 'viewSettings/settingsHelper';
import { markTypeDropdown } from '../markTypeMenu';

const VIEW_ID = ViewIds.SPIDER_2;

export const toggleFieldName = (
  selectedFieldNames: string[],
  fieldName: string
): string[] =>
  selectedFieldNames.includes(fieldName)
    ? selectedFieldNames.filter(name => name !== fieldName)
    : [...selectedFieldNames, fieldName];

const fieldsDropdown = (
  { selectedFieldNames }: SpiderViewSettings,
  numericFields: NumericField[],
  i18nLocale: I18nLocale
): SettingsConfig => ({
  id: 'spider2Fields',
  type: SettingsType.DROPDOWN,
  iconName: IconName.FORMAT_LIST_BULLETED,
  label: t(i18nLocale, 'views:spider2.menu.fields', 'Fields'),
  options: numericFields.map(({ name, label }) => ({
    name: `spider2Fields_${name}`,
    label,
    type: DropdownOptionType.OPTION,
    isActive: selectedFieldNames.includes(name),
    onClick: () =>
      handleStoreSetting(VIEW_ID, {
        selectedFieldNames: toggleFieldName(selectedFieldNames, name),
      }),
  })),
  isKeepOpen: true,
  isDisabled: numericFields.length === 0,
  dropdownSize: DropdownSize.S,
});

export type SpiderViewModifiersArgs = {
  viewSettings: SpiderViewSettings;
  numericFields: NumericField[];
  i18nLocale: I18nLocale;
};

export const getSpiderViewModifiers = ({
  viewSettings,
  numericFields,
  i18nLocale,
}: SpiderViewModifiersArgs): SettingsConfig[] => [
  fieldsDropdown(viewSettings, numericFields, i18nLocale),
  markTypeDropdown({
    viewId: VIEW_ID,
    id: 'spider2MarkType',
    markType: viewSettings.markType,
    i18nLocale,
  }),
];
